<template>
  <div class="user-profile">
    <!-- loading untill all data loaded -->
    <loading-spinner v-if="!data_loading"></loading-spinner>
    <!-- end loading --->
    <div class="m-container" v-else>
      <div class="row">
        <!-- mobile side bar -->
        <div class="mobile-side-bar">
          <ul>
            <li :class="addActiveClass('teams')" @click="changeComponent('teams')"><i class="fas fa-users"></i></li>
            <li :class="addActiveClass('gamePage')" @click="changeComponent('gamePage')"><i class="fas fa-gamepad"></i>
            </li>
            <li :class="addActiveClass('event')" @click="changeComponent('event')"><i class="far fa-calendar-alt"></i>
            </li>
            <!--              <li :class="addActiveClass('supportTicket')" @click="changeComponent('supportTicket')"><i class="fas fa-ticket-alt"></i></li>-->
            <li :class="addActiveClass('Notification')" @click="changeComponent('Notification')"><i
                class="far fa-bell"></i></li>
            <li :class="addActiveClass('ProfileUser')" @click="changeComponent('ProfileUser')"><i
                class="far fa-address-card"></i></li>
            <li :class="addActiveClass('changePassword')" @click="changeComponent('changePassword')"><i
                class="fas fa-unlock-alt"></i></li>
            <li :class="addActiveClass('logout')" @click="logOut"><i class="fas fa-sign-out-alt"></i></li>
            <li v-if="matchTime" :class="addActiveClass('submit-video')" @click="changeComponent('submitVideo')"><i
                class="fab fa-youtube"></i></li>
          </ul>
        </div>
        <!-- end mobile saide bar -->
        <!-- desk top side bar menu -->
        <div class="col-md-3 the-menu">
          <div class="the-menu-body">
            <div>
              <p>menu</p>
            </div>
            <ul>
              <li :class="addActiveClass('Teams')" @click="changeComponent('Teams')"><i class="fas fa-users"></i>Teams
              </li>
              <li :class="addActiveClass('gamePage')" @click="changeComponent('gamePage')"><i
                  class="fas fa-gamepad"></i>Game Page
              </li>
              <li :class="addActiveClass('Event')" @click="changeComponent('Event')"><i
                  class="far fa-calendar-alt"></i>Events</li>
              <!--                <li :class="addActiveClass('supportTicket')" @click="changeComponent('supportTicket')"><i class="fas fa-ticket-alt"></i>Support Ticket </li>-->
              <li :class="addActiveClass('Notification')" @click="changeComponent('Notification')"><i
                  class="far fa-bell"></i>Notifications</li>
              <li :class="addActiveClass('ProfileUser')" @click="changeComponent('ProfileUser')"><i
                  class="far fa-address-card"></i>Profile
              </li>
              <li :class="addActiveClass('changePassword')" @click="changeComponent('changePassword')"><i
                  class="fas fa-unlock-alt"></i>Change Password
              </li>
              <li :class="addActiveClass('logout')" @click="logOut"><i class="fas fa-sign-out-alt"></i>Log Out</li>
              <li v-if="matchTime" :class="addActiveClass('SubmitVideo')" @click="changeComponent('SubmitVideo')"><i
                  class="fab fa-youtube"></i> Submit Video</li>
            </ul>
          </div>
        </div>
        <!-- end desk top side bar menu -->
        <div class="col-xs-12 col-sm-12 col-md-9 controll-info">
          <div class="profile-content">
            <component :is="component"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileUser from "@/components/user/ProfileUser";
import gamePage from "@/components/user/GamePage/GamePage";
import changePassword from "@/components/user/ChangePassword";
import Teams from "@/components/user/Teams/Teams";
import Event from "@/components/user/Event/Event";
import LoadingSpinner from "../../components/tools/LoadingSpinner";
import Notification from "@/components/user/Notification";
import SubmitVideo from "@/components/user/SubmitVideo";

import moment from 'moment'


export default {
  components: { LoadingSpinner, ProfileUser, gamePage, changePassword, Teams, Event, Notification, SubmitVideo },
  data: () => ({
    data_loading: false,
    component: 'Teams'
  }),
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    matchTime() {
      return moment().format('YYYY-MM-DD') <= moment("2023-06-30").format('YYYY-MM-DD')
    }
  },
  watch: {
    '$route.query'() {
      if (this.$route.query.hasOwnProperty('page')) this.component = this.$route.query.page;
    }
  },
  created() {
    this.$API.userProfile.getProfile()
      .then(response => {
        this.data_loading = true;
        this.$store.commit('getUserData', response.data.data);
      }).catch(err => {
        // make log out if something is worng or token is expierd
        if (err.response.data.status === false) {
          this.logOut();
        }
      });


    if (this.$route.query.page === 'Notification') {
      this.component = 'Notification';
    }

  },
  methods: {
    changeComponent(e) {
      console.log(e);
      this.$router.push({ query: { page: e } });
      this.component = e;
    },
    addActiveClass(e) {
      if (this.component == e) return 'active-component';
    },
    logOut() {
      this.$store.commit('editUserState', false);
      this.$store.commit('getUserToken', null);
      this.$store.commit('getUserData', null);
      this.$store.commit('get_userTeam', null);
      localStorage.removeItem('token');
      // push to home page
      this.$router.push('/');
    }
  }
}

</script>

<style>
.user-profile {
  margin-top: 27px;
  min-height: 75vh;
}

.user-profile .the-menu {

  border-right: 2px solid var(--mainColors);
  margin-bottom: 85px;
}

.user-profile .the-menu .the-menu-body {
  padding-right: 17px;
}

.user-profile .the-menu .the-menu-body div p {
  font-size: 0.875rem;
  font-weight: bold;
  text-transform: uppercase;
  padding: 0px 46px;

}

.user-profile .the-menu .the-menu-body ul {
  padding: 0px;
}

.user-profile .the-menu .the-menu-body ul li {
  font-size: 1.063rem;
  color: #7C7C7C;
  margin: 27px 0px;
  cursor: pointer;
  padding: 0px 46px;
  transition: 0.2s ease all;
}

.user-profile .the-menu .the-menu-body ul li i {
  margin-right: 10.6px;
}

.user-profile .controll-info {
  padding-left: 27px;
}

.user-profile .controll-info .profile-content {
  padding-top: 44.5px;
}


.active-component {
  background: #E9ECFA;
  color: var(--mainColors) !important;
  border-right: 4px solid var(--mainColors);
  padding: 16px 46px !important;
}


/* Mobile side bar css style */
.mobile-side-bar {
  width: 100%;
  background: #cccccc;
  display: none;
}

.mobile-side-bar ul {
  padding: 0px;
  text-align: center;
}

.mobile-side-bar ul li {
  display: inline-block;
  margin: 0px 25px;
}


@media (max-width: 1025px) {
  .the-menu {
    display: none;
  }

  .mobile-side-bar {
    display: block;
  }

  .active-component {
    background: none;
    color: var(--mainColors) !important;
    border-right: 0px;
    padding: 0px !important;
  }


}
</style>